<template>
    <div>
        <v-card>
            <v-card-title>Remark for host</v-card-title>
            <v-card-text>
                Remark will be added to this booking on the "My Villa" website of this host<br>
                Use less than 1000 characters, and the language of the host
            </v-card-text>
            <v-textarea class="px-4 pb-0" v-model="huov.huov_opm_vfy" label="Private remark for host" outlined counter dense></v-textarea>
            <v-divider></v-divider>
            <v-card-actions>
                <div class="ml-2"><v-btn class="primary" x-small v-on:click="saveRemark">Update remark</v-btn></div>
                
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

    export default {
        props: {
            huov: Object,
        },        
        data() {
            return {
            }
        },
        methods: {         
            saveRemark() {
                //console.log(this.huov.huov_encrid)
                //console.log(this.huov.huov_opm_vfy)
                this.$axios.post("ares/json/ares/huov/updHuovOpmVfy.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updHuovOpmVfy"
                    },
                    updHuovOpmVfy: {
                        huov_encrid: this.huov.huov_encrid,
                        huov_opm_vfy: this.huov.huov_opm_vfy
                    }
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.updHuovOpmVfy.text,
                            color: res.data.updHuovOpmVfy.color,
                        });
                        //console.log(res);
                    }
                });   
            },               
        }
    }
</script>

<style scoped>
</style>